import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import { Button, Grid } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import { FormEvent, useMemo, useState } from "react";
import DataTable from "../../../common/components/dataTable";
import ErrorBadge from "../../../common/components/forms/errorBadge";
import FormHeader from "../../../common/components/forms/formHeader";
import LoadingIndicator from "../../../common/components/loadingIndicator";
import { useUnidadeNegocioGuard } from "../../../common/hooks/useUnidadeNegocioGuard";
import PageLayout from "../../../common/layouts/pageLayout";

import {
  useCorrespondenciasRolex,
  useCreateCorrealacaoRolex,
  useDeleteCorrespondenciaRolex,
} from "./rolex.hooks";
import { useHistory } from "react-router";
import { Form } from "react-final-form";
import QCXSelectPartNumberAutocomplete from "../../../../shared-components/select-catalogo-produto/QCXSelectPartNumberAutocomplete";
import { useSelector } from "react-redux";

interface CorrespondenciaRolexType {
  id?: number;
  partnumber: string;
  descricao: string;
  codigoExterno: string;
  quickcomexId: string;
}

const RolexCorrespondenciaPage = () => {
  useUnidadeNegocioGuard();
  const history = useHistory();

  const [correlacoes, isCorrelacoesLoading] = useCorrespondenciasRolex();
  const [createCorrelacao, isCreating, hasCreateError] = useCreateCorrealacaoRolex();
  const [deleteCorrelacao, isDeleting, hasDeleteError] = useDeleteCorrespondenciaRolex();

  const [error, setError] = useState<string>();
  const produtosNoRedux = useSelector((state: any) => state.catalogoProdutos.list);

  const handleDetailsNavigation = (params: any) => {
    history.push({
      pathname: `/integracao/rolex/correspondencias/${params.row.id}`,
    });
  };

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "partnumber",
        headerName: "PartNumber",
        flex: 1,
        headerClassName: "header-theme",
      },
      {
        field: "descricao",
        headerName: "Especificação do Produto",
        flex: 2,
        headerClassName: "header-theme",
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Ações",
        headerClassName: "header-theme",
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            placeholder=""
            icon={<SearchIcon />}
            label="Consultar"
            onClick={() => handleDetailsNavigation(params)}
            showInMenu
          />,
          <GridActionsCellItem
            placeholder=""
            icon={<DeleteIcon />}
            label="Excluir"
            onClick={() => deleteCorrelacao({ id: params.row.id })}
            showInMenu
          />,
        ],
      },
    ],
    []
  );

  const rows: any[] = useMemo(() => {
    return (correlacoes ?? []).map((item: any) => ({
      id: item.id ?? 0,
      partnumber: item.partnumber,
      descricao: item.descricao,
      quickcomexId: item.quickcomexId,
    }));
  }, [correlacoes]);

  const onSubmit = (values: any, form: any) => {
    const qcxProdutoId = values.qcxProdutoId;

    if (!qcxProdutoId) return;

    const produtoSelecionado = produtosNoRedux?.find((p: any) => String(p.id) === String(qcxProdutoId));

    const novaCorrespondencia: Partial<CorrespondenciaRolexType> = {
      partnumber: produtoSelecionado?.partnumber ?? "N/A",
      descricao: produtoSelecionado?.especificacao ?? produtoSelecionado?.description ?? "",
      quickcomexId: qcxProdutoId.toString(),
    };

    createCorrelacao({ requestPayload: novaCorrespondencia });
    setError(undefined);
    form.restart();
  };


  return (
    <PageLayout
      title={"Rolex - Correspondência Produtos"}
      icon={<HistoryEduIcon color={"secondary"} />}
    >
      {isCorrelacoesLoading ? (
        <LoadingIndicator />
      ) : (
        <Grid container spacing={2}>
          <FormHeader marginTop="0">
            Produtos Vinculados
          </FormHeader>

          <Grid item sm={12}>
            <DataTable
              columns={columns}
              rows={rows}
            ></DataTable>
          </Grid>

          <Grid item sm={12}>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit, values, form, submitting }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <FormHeader marginTop="0">Novo Vínculo</FormHeader>

                    <Grid item sm={12}>
                      <QCXSelectPartNumberAutocomplete
                        label="SELECIONE O PRODUTO (QUICKCOMEX)"
                        name="qcxProdutoId"
                      />
                    </Grid>

                    <Grid item sm={12} textAlign="right">
                      <Button
                        disabled={!values.qcxProdutoId || isCreating || submitting}
                        type="submit"
                        variant="contained"
                        color="secondary"
                      >
                        {isCreating || submitting ? "Salvando..." : "Salvar"}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </Grid>
          {error && <ErrorBadge error={error} />}
          {hasCreateError && <ErrorBadge error="Erro ao criar vínculo." />}
          {hasDeleteError && <ErrorBadge error="Erro ao excluir vínculo." />}
        </Grid>
      )}
    </PageLayout>
  );
};

export default RolexCorrespondenciaPage;